export const STOP_LOADING_STAFF = "STOP_LOADING_STAFF";
export const GET_STAFF_DATA = "GET_STAFF_DATA";
export const SET_STAFF_DATA = "SET_STAFF_DATA";
export const ADD_STAFF = "ADD_STAFF";
export const SET_CURRENT_STAFF = "SET_CURRENT_STAFF";
export const EDIT_STAFF = "EDIT_STAFF";
export const DELETE_STAFF = "DELETE_STAFF";
export const RESEND_ACTIVATION_EMAIL = "RESEND_ACTIVATION_EMAIL";
